import { render, staticRenderFns } from "./ActivityModalForm.vue?vue&type=template&id=b1d6fb84&scoped=true"
import script from "./ActivityModalForm.vue?vue&type=script&lang=ts"
export * from "./ActivityModalForm.vue?vue&type=script&lang=ts"
import style0 from "./ActivityModalForm.vue?vue&type=style&index=0&id=b1d6fb84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d6fb84",
  null
  
)

export default component.exports